import axios from "axios";

export default class AdfResource
{
    constructor ()
    {
        this.createClosure();
        this.bindEvents();
    }

    createClosure()
    {
        this.fctCheckForAccess = this.checkForAccess.bind(this)
        this.fctShowNoAccess = this.clickShowNoAccess.bind(this)
        this.fctGetUserInfo = this.getUserInfo.bind(this)
    }



    bindEvents ()
    {
        // this.btnShowAccess = document.querySelector("[data-btn-show-access-code]")
        // this.btnShowAccess.addEventListener("click", this.fctCheckForAccess);
        //
        // window.addEventListener("popup-ready", this.fctCheckForAccess);


        this.arrBtnNoAccess = Array.from(document.querySelectorAll("[data-lock='true']"));

        this.arrBtnNoAccess.forEach( btn => btn.addEventListener("click", this.fctShowNoAccess))

        console.log("this.arrBtnNoAccess", this.arrBtnNoAccess)

        if (this.arrBtnNoAccess.length > 0)
        {
            window.addEventListener("on-user-info", this.fctCheckForAccess );
        }
    }

    getUserInfo (user)
    {
        window.__login__.show();

    }

    checkForAccess ()
    {
        let noAccess = document.querySelector("[data-no-access]");

        if (noAccess)
        {
            this.showNoAccess(noAccess.attributes["data-id"].value)
        }
    }

    async clickShowNoAccess (event)
    {
        event.preventDefault();

        let target = event.target;
        let strDataId = target.attributes["data-id"].value;

        let response = await axios.post("/endpoints/have-privileged-access", {id: strDataId});
        let data = response.data;

        if (data.success === true)
        {
            let url = data.data.url;

            window.open(url);
        }
        else
        {
            if (!data.data)
            {
                this.showConnection();
            }
            else
            {
                let haveAsk = data.data.haveAsk ?? 0;
                this.showNoAccess(haveAsk);
            }
        }

    }

    showConnection ()
    {
        if (!this.userDialog) //first time
        {
            this.userDialog = document.querySelector("#dialog_login");

            this.userDialog.addEventListener("click", (e) =>
            {
                //clicking on the backdrop let us close the modal
                if (!e.target.closest("div"))
                {
                    //e.target.close();
                    window.__login__.close();
                }
            })
        }

        if (window.__login__)
        {
            window.__login__.show("connexion");
        }
    }

    showNoAccess (haveAsk = 0)
    {
        if (!this.userDialog) //first time
        {
            this.userDialog = document.querySelector("#dialog_login");

            this.userDialog.addEventListener("click", (e) =>
            {
                //clicking on the backdrop let us close the modal
                if (!e.target.closest("div"))
                {
                    //e.target.close();
                    window.__login__.close();
                }
            })
        }

        if (window.__login__)
        {
            window.__login__.show("no-access", {haveAsk} );
        }
    }
}
